import React from 'react';

const PaymentErrorModal = ({ show, onClose, errorType, souscriptionReference, errorMessage }) => {
  if (!show) return null;

  const getErrorConfig = () => {
    switch (errorType) {
      case 'no_logement':
        return {
          title: 'Aucun logement associé',
          icon: (
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
            </svg>
          ),
          message: 'Cette souscription n\'a aucun logement associé. Veuillez d\'abord modifier la souscription pour sélectionner un logement disponible avant de procéder au paiement.',
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200'
        };
      case 'logement_unavailable':
        return {
          title: 'Logement non disponible',
          icon: (
            <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
          ),
          message: 'Le logement associé à cette souscription n\'est plus disponible (statut: occupé). Veuillez sélectionner un autre logement disponible avant de procéder au paiement.',
          bgColor: 'bg-orange-50',
          borderColor: 'border-orange-200'
        };
      default:
        return {
          title: 'Erreur de paiement',
          icon: (
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
          ),
          message: errorMessage || 'Une erreur s\'est produite lors de la vérification des conditions de paiement.',
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200'
        };
    }
  };

  const config = getErrorConfig();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full shadow-2xl transform animate-slideIn">
        {/* Header */}
        <div className={`px-6 py-4 border-b ${config.borderColor} ${config.bgColor} rounded-t-lg`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                {config.icon}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {config.title}
                </h3>
                <p className="text-sm text-gray-600">
                  Référence: {souscriptionReference}
                </p>
              </div>
            </div>
            {/* Bouton fermer */}
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors duration-200 bg-white rounded-full p-2 shadow-md"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="text-center">
            <div className={`mx-auto flex items-center justify-center h-16 w-16 rounded-full ${config.bgColor} mb-4`}>
              {config.icon}
            </div>
            <h4 className="text-lg font-medium text-gray-900 mb-4">
              Paiement impossible
            </h4>
            <p className="text-sm text-gray-600 leading-relaxed mb-6">
              {config.message}
            </p>
            
            <div className="space-y-3">
              <button
                onClick={onClose}
                className="w-full px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 font-medium"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentErrorModal;